import { createContext } from 'react';

export const PredicateStoreContext = createContext(null);
